var _templateObject = _taggedTemplateLiteralLoose(['\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n'], ['\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  fill: none;\n  stroke: white;\n  stroke-width: 2px;\n'], ['\n  fill: none;\n  stroke: white;\n  stroke-width: 2px;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin: 0 5px 0 0;\n  cursor: pointer;\n  background: ', ';\n  border: 1px solid ', ';\n  transition: all 150ms;\n  ', ' {\n    visibility: ', '\n  }\n'], ['\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin: 0 5px 0 0;\n  cursor: pointer;\n  background: ', ';\n  border: 1px solid ', ';\n  transition: all 150ms;\n  ', ' {\n    visibility: ', '\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  vertical-align: middle;\n'], ['\n  display: inline-block;\n  vertical-align: middle;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Theme from '../../Theme';

var HiddenCheckbox = styled.input.attrs(function (props) {
  return {
    type: 'checkbox'
  };
})(_templateObject);

var Icon = styled.svg(_templateObject2);

export var StyledCheckbox = styled.div(_templateObject3, function (props) {
  return props.checked ? Theme.colors.lightBlue : 'white';
}, function (props) {
  return props.checked ? Theme.colors.lightBlue : Theme.colors.pearlGrey;
}, Icon, function (props) {
  return props.checked ? 'visible' : 'hidden';
});

var CheckboxContainer = styled.div(_templateObject4);

var CheckBox = function CheckBox(_ref) {
  var checked = _ref.checked;
  return React.createElement(
    CheckboxContainer,
    null,
    React.createElement(HiddenCheckbox, { checked: checked, onChange: function onChange() {
        return null;
      } }),
    React.createElement(
      StyledCheckbox,
      { checked: checked },
      React.createElement(
        Icon,
        { viewBox: '0 0 24 24' },
        React.createElement('polyline', { points: '20 6 9 17 4 12' })
      )
    )
  );
};

CheckBox.displayName = 'CheckBox';
CheckBox.propTypes = process.env.NODE_ENV !== "production" ? {
  checked: PropTypes.bool
} : {};

export default CheckBox;